import { render, staticRenderFns } from "./AlertaBarredores.vue?vue&type=template&id=460f9631&scoped=true&"
import script from "./AlertaBarredores.vue?vue&type=script&lang=ts&"
export * from "./AlertaBarredores.vue?vue&type=script&lang=ts&"
import style0 from "./AlertaBarredores.vue?vue&type=style&index=0&id=460f9631&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460f9631",
  null
  
)

export default component.exports